/* Reset della quantità a 1 dopo l'aggiunta al carrello dalle product card. */
(function () {
  'use strict';

  var pending = null;

  function reset(form) {
    if (!form) return;
    var input = form.querySelector('[data-cb-qty-reset]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    input.value = min;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function flush() {
    var form = pending;
    pending = null;
    reset(form);
  }

  // Fase di capture: intercetta il submit prima che il tema lo gestisca.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('.product-item__cta-row');
    if (!form) return;
    pending = form;
    setTimeout(flush, 1500); // fallback se nessun evento carrello viene emesso
  }, true);

  ['cart:refresh', 'cart:updated', 'variant:added'].forEach(function (name) {
    document.addEventListener(name, flush);
  });
})();